var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "58", height: "56", viewBox: "0 0 58 56", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("rect", { x: "1", width: "56", height: "56", rx: "28", fill: "#fff" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22.125 18.625C22.125 14.828 25.203 11.75 29 11.75C32.797 11.75 35.875 14.828 35.875 18.625V19.25C35.875 23.047 32.797 26.125 29 26.125C25.203 26.125 22.125 23.047 22.125 19.25V18.625Z", fill: "#A2E1E2" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.25 40.5C15.25 33.2513 21.1263 27.375 28.375 27.375H30.25C37.4987 27.375 43.375 33.2513 43.375 40.5C43.375 42.2259 41.9759 43.625 40.25 43.625H18.375C16.6491 43.625 15.25 42.2259 15.25 40.5Z", fill: "#62CACD" }),
    React.createElement(
      "mask",
      { id: "id-87a", style: {
          maskType: "luminance"
        }, maskUnits: "userSpaceOnUse", x: "15", y: "27", width: "29", height: "17" },
      React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.25 40.5C15.25 33.2513 21.1263 27.375 28.375 27.375H30.25C37.4987 27.375 43.375 33.2513 43.375 40.5C43.375 42.2259 41.9759 43.625 40.25 43.625H18.375C16.6491 43.625 15.25 42.2259 15.25 40.5Z", fill: "#fff" })
    ),
    React.createElement(
      "g",
      { mask: "url(#id-87a)", fillRule: "evenodd", clipRule: "evenodd" },
      React.createElement("path", { d: "M32.75 27.375H45.25V45.5H30.875L32.75 27.375Z", fill: "#4AABB0" }),
      React.createElement("path", { d: "M32.75 27.375L36.5 30.8125L31.5 40.5L32.75 27.375Z", fill: "#018489" }),
      React.createElement("path", { d: "M25.875 27.375H13.375V45.5H27.75L25.875 27.375Z", fill: "#4AABB0" }),
      React.createElement("path", { d: "M26 27.375L22.25 30.8125L27.25 40.5L26 27.375Z", fill: "#018489" })
    ),
    React.createElement("rect", { x: "1", width: "56", height: "56", rx: "28", stroke: "#ECECEC" })
  );
});